module.exports = __webpack_public_path__ + "img/emoji_035.a82b0342.png";